import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { animated, useSpring } from 'react-spring'
import useOnClickOutSide from '../../hooks/useOnClickOutside'
import { desktopVw } from '../../styles/utils'
import useBodyScrollLock from '../../hooks/useBodyScrollLock'
import { Overlay } from './Overlay'
import CloseIcon from '../../assets/close.svg'
import { useTranslation } from 'next-i18next'

const StyledDrawer = styled(animated.aside)`
  z-index: 2001;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  padding: 25px 30px;

  background: ${props => props.theme.colors.secondary};
  overflow-y: scroll;
  -ms-overflow-style: none;

  @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
    left: unset;
    width: ${desktopVw(480)};
    padding: ${desktopVw(33)} ${desktopVw(65)};
    box-shadow: ${({ isDrawerOpen }) => (isDrawerOpen ? `#2B2D2F 0px 0px 5px 0px` : `none`)};
  }
`

const StyledCloseIcon = styled(CloseIcon)`
  path {
    fill: ${props => props.theme.colors.primary};
  }
`

const Close = styled.button`
  position: absolute;
  z-index: 1;
  top: 28px;
  right: 30px;
  width: 15px;
  cursor: pointer;
  display: ${props => (props.hideMobile ? 'none' : 'block')};

  @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
    display: ${props => (props.hide ? 'none' : 'block')};
    top: ${desktopVw(30)};
    right: ${desktopVw(30)};
    width: ${desktopVw(11)};
  }
`

function Drawer({ open, onClose, children, hideClose, hideCloseMobile, closeOnOverlayClickOnly }) {
  const { t } = useTranslation('common')
  const [pseudoOpen, setPseudoOpen] = useState(false)

  useBodyScrollLock(open)

  useEffect(() => {
    setTimeout(() => {
      setPseudoOpen(open)
    }, 200)
  }, [open])

  const slideOutAnim = useSpring({
    transform: pseudoOpen ? `translate3d(0, 0, 0)` : ` translate3d(100%, 0, 0)`,
  })

  function handlePseudoClose() {
    setPseudoOpen(false)
    setTimeout(() => {
      onClose()
    }, 200)
  }

  const [ref] = useOnClickOutSide(() => open && !closeOnOverlayClickOnly && handlePseudoClose())

  return (
    <>
      {open && <Overlay opacity onClick={closeOnOverlayClickOnly ? handlePseudoClose : undefined} />}
      <StyledDrawer ref={ref} isDrawerOpen={open} style={slideOutAnim} className="side__modal__container">
        <Close
          className="modal__close_button"
          // @i18n-ignore
          type="button"
          aria-label={t('close_v1')}
          onClick={handlePseudoClose}
          hide={hideClose}
          hideMobile={hideCloseMobile}
        >
          <StyledCloseIcon />
        </Close>
        {children}
      </StyledDrawer>
    </>
  )
}

export default Drawer
